module.exports = __webpack_public_path__ + "static/media/purple-tile-bordered.3c8f646c.png";